<template>
	<div class="userMessage" :style="mainContentViewHeight">
		<!-- <el-form :inline="true" :model="dataForm" @submit.native.prevent @keyup.enter.native="getDataList()">
			<el-form-item label="关键字：">
				<el-input v-model="dataForm.content" placeholder="请输入关键字" clearable></el-input>
			</el-form-item>
			<el-form-item label="发送人：">
				<el-input v-model="dataForm.sendUser" placeholder="请输入关键字" clearable></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary"  @click="getDataList()">查询</el-button>
				<el-button  @click="refresh()">重置</el-button>
			</el-form-item>
			<el-button type="primary" style="float: right" @click="handleUpdateReadStatus()">一键已阅</el-button>
		</el-form>

		<el-table
			:data="dataList"
			border
			stripe
			v-loading="dataListLoading"
			:row-class-name="tableRowClassName"
			@sort-change="sortChange"
			style="width: 100%;">
			<el-table-column label="序号"
				type="index"
				:index="indexMethod"
				width="70"
				align="center">
			</el-table-column>
			<el-table-column label="状态"
				prop='content'
				width="100"
				align="center">
				<template slot-scope="scope" >
					<i :class="formattStatus(scope.row.status,'class')"></i>
					<span class="tag-status" :class="setClass(scope.row.status)">{{formattDictionaryData(statusList,scope.row.status,'value','name')}}</span>
				</template>
			</el-table-column>
			<el-table-column
				prop="content"
				align="left"
				header-align="left"
				:show-overflow-tooltip="true"
				label="内容">
				<template slot-scope="scope">
					<span style="cursor: pointer" @click="handleUpdateReadStatus(scope.row)">{{scope.row.content}}</span>
				</template>
			</el-table-column>
			<el-table-column
				prop="sendUser"
				align="center"
				width="180"
				:sortable="true"
				label="发送人">
			</el-table-column>
			去掉<el-table-column
				prop="sendType"
				align="center"
				:sortable="true"
				width="120"
				label="发送方式">
				<template slot-scope="scope">
					<span>{{ $pmUtils.formattDictionaryData(sendOptionList,scope.row.sendType,'id','text')}}</span>
				</template>
			</el-table-column>
			<el-table-column
				prop="sendTime"
				align="center"
				width="180"
				:sortable="true"
				label="发送时间">
			</el-table-column>
			去掉<el-table-column
				header-align="center"
				align="center"
				width="100"
				label="操作">
				<template slot-scope="scope">
					<el-button type="text" size="mini" @click="showDetail(scope.row.id,scope.row.appId)">查看</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination
			@size-change="sizeChangeHandle"
			@current-change="currentChangeHandle"
			:current-page="pageIndex"
			:page-sizes="[10, 20, 50, 100]"
			:page-size="pageSize"
			:total="totalPage"
			layout="total, sizes, prev, pager, next, jumper">
		</el-pagination> -->
		<div class="top">
			<p>
                <span class="title">消息中心</span>
            </p>
            <div class="userMessage-search">
                <el-input placeholder="请输入消息" v-model="dataForm.content" clearable></el-input>
                <el-button class="search-btn" type="primary" @click="getDataList()">搜索</el-button>
            </div>
		</div>
		<div class="table-content">
			<el-button type="primary" size="medium" @click="handleUpdateReadStatus()">一键已阅</el-button>
			<el-table
				:data="dataList"
				border
				stripe
                size="mini"
				v-loading="dataListLoading"
				:row-class-name="tableRowClassName"
				@sort-change="sortChange"
				style="width: 100%;margin-top:16px;"
				:height="tableMaxHeight"
			>
				<el-table-column label="序号"
					type="index"
					:index="indexMethod"
					width="70"
					align="center">
				</el-table-column>
				<el-table-column label="状态"
					prop='content'
					width="100"
					align="center">
					<template slot-scope="scope" >
						<i :class="formattStatus(scope.row.status,'class')"></i>
						<span class="tag-status" :class="setClass(scope.row.status)">{{formattDictionaryData(statusList,scope.row.status,'value','name')}}</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="content"
					align="left"
					header-align="left"
					:show-overflow-tooltip="true"
					label="内容">
					<template slot-scope="scope">
						<span style="cursor: pointer" @click="handleUpdateReadStatus(scope.row)">{{scope.row.content}}</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="sendUser"
					align="center"
					width="180"
					:sortable="true"
					label="发送人">
				</el-table-column>
				<el-table-column
					prop="sendTime"
					align="center"
					width="180"
					:sortable="true"
					label="发送时间">
				</el-table-column>
			</el-table>
			<!-- <el-pagination
				@size-change="sizeChangeHandle"
				@current-change="currentChangeHandle"
				:current-page="pageIndex"
				:page-sizes="[10, 20, 50, 100]"
				:page-size="pageSize"
				:total="totalPage"
				layout="total, sizes, prev, pager, next, jumper">
			</el-pagination> -->
            <pagination
                    class="limit"
                    :page-sizes="[10, 20, 50, 100]"
                    :total="totalPage"
                    :page.sync="pageIndex"
                    :limit.sync="pageSize"
                    @pagination="paginationChange">
                </pagination>
		</div>
	</div>
</template>

<script>
import {getEnumListReq} from "@/server/msg";
import {formattDictionaryData} from "@/utils/index";
import Pagination from '@/components/Pagination.vue';
export default {
	props: ['mainContentViewHeight'],
	components: {Pagination},
	data() {
		return {
			tableMaxHeight: document.documentElement.clientHeight - 88 - 20 - 60 - 40 - 44 - 20 - 110, //top筛选 边距 内边距 搜索 默认
			dataForm: {
				content:'',
				sendUser:'',
			},
			statusList:[
				{name:'失败',value:'-1'},
				{name:'未发送',value:'0'},
				{name:'未阅读',value:'1'},
				{name:'已阅读',value:'2'},
			],
			appList:[],
			sendOptionList:[],
			dataList: [],
			searchKey: '',
			pageIndex: 1,
			pageSize: 10,
			totalPage: 0,
			userPageIndex: 1,
			userPageSize: 10,
			userTotalPage: 0,
			appListLoading:false,
			dataListLoading: false,
			dataListSelections: [],
			selectItem: {id: ''},
			selectRoleVisible: false,
			selectOrgRoleVisible: false,
			drawerVisible:false,
			sortParams: {
				order:'',
				prop:''
			},
		}
	},

	created() {
		// this.getSendOptionList()
	},

	mounted() {
		this.getDataList()
	},
	computed: {
		isSupperAdmin: {
			get() {
				return this.$store.state.user.supperAdmin === true || this.$store.state.user.supperAdmin === 'true'
			}
		},
		userinfo: {
			get () {
				return this.$store.state.user.userinfo
			}
		},
		leftContentViewHeight: {
			get() {
				return {minHeight: this.mainContentViewHeight.minHeight}
			}
		},
		selectItemId: {
			get() {
				return this.selectItem.id
			}
		}
	},
	methods: {
		formattDictionaryData,
		formattStatus(status,type){
			if(type == 'class'){
				switch(status){
					case "2": return 'icon-point icon-point-success'; break;
					case "1": return 'icon-point icon-point-verificationing'; break;
					case "0": return 'icon-point icon-point-info'; break;
					case "-1": return 'icon-point icon-point-danger'; break;
					default:return ''; break;
				}
			}
		},
		setClass(status) {
			switch(status){
				case "2": return 'icon-point icon-point-success'; break;
				case "1": return 'icon-point icon-point-verificationing'; break;
				case "0": return 'icon-point icon-point-info'; break;
				case "-1": return 'icon-point icon-point-danger'; break;
				default:return ''; break;
			}
		},
		getSendOptionList(){
			getEnumListReq(this.$http,13).then(({data}) => {
				if (data) {
					let resData = data || [];
					this.sendOptionList = Array.isArray(resData)?resData:[]
				} else {
					this.sendOptionList = [];
				}
			})
		},
		tableRowClassName({row, rowIndex}) {
			console.log(row.status)
			if (row.status == '1') {
				return 'unread-row';
			}
			return '';
		},
		handleUpdateReadStatus(row){
			let params = {};
			if(row){params.id=row.id;}
			this.$http.post('/basic/msg/updateMsgRead', params, {baseURL: '/sso'}).then(({data}) => {
				if (data.code != '1'){
					this.$message.error(data.msg)
					return
				}
				this.getDataList();
			})
		},
		sortChange(column, prop, order){
			this.sortParams.prop = prop || column.prop;
			this.sortParams.order = order || column.order;
			this.getDataList();
		},
		dialogCancle() {
			this.drawerVisible = false
		},
		reloadData() {
			this.getDataList()
		},
		getRowsIndex(index) {
			return (this.pageIndex - 1) * this.pageSize + index + 1
		},
		getAppId() {
			this.dataForm.appId
		},
		handleCateClick(item) {
			this.selectItem = item
			this.getDataList()
		},
		refresh() {//刷新按钮
			this.pageIndex = 1;
			this.dataForm.content = "";
			this.dataForm.sendUser = "";
			this.getDataList()
		},
		getDataList() {
			let url = '/basic/msg/logList'
			let params = {
				'page': this.pageIndex,
				'rows': this.pageSize,
				'orderBy':(this.sortParams.prop && this.sortParams.order)?(this.sortParams.prop + (this.sortParams.order == "ascending"?' asc':' desc')):"",
				'filter': {
					"receiveUserId":this.userinfo.userId,
					'searchContent':this.dataForm.content || null,
					'searchSendUser':this.dataForm.sendUser || null,
					ignoreFlag: true,
				}
			}
			this.$http.post(url, params, {
				baseURL: '/sso'
			}).then(({data}) => {
				if (data) {
					this.dataList = data.rows;
					this.totalPage = data.total;
				} else {
					this.dataList = []
					this.totalPage = 0
				}
				this.dataListLoading = false
			})
		}, 
		// 每页数
		indexMethod(index) {
			return (this.pageIndex - 1) * this.pageSize + index + 1
		},
		sizeChangeHandle(val) {
			this.pageSize = val
			this.pageIndex = 1
			this.getDataList()
		},
		// 当前页
		currentChangeHandle(val) {
			this.pageIndex = val
			this.getDataList()
		},
        paginationChange(obj){
         this.pageIndex= obj.page||1
         this.pageSize=obj.limit||10
         this.getDataList();
        },
		deleteSelectHandle(){
			let ids = new Array();
			this.dataListSelections.forEach(key => {
				ids.push(key.id)
			})
			if (ids != "" || ids.length > 0) {
				this.$http.post('/***', {
					idList: ids
				}).then(res => {
					if (res.data.code == '1') {
						this.$message({
							type: 'success',
							message: res.data.msg
						})
						this.getDataList();
					} else {
						this.$message({
							type: 'error',
							message: res.data.msg
						})
					}
				})
			} else {
				this.$message({
					type: 'error',
					message: "未选择删除项。"
				})
			}
		},
		showDetail(id,appId){
			this.$http.get('/basic/msg/getLogInfo/' + id, {}).then(({data}) => {
				console.log(data)
			})
		},
	}
}
</script>

<style scoped lang="less">
.userMessage {
	.top {
		background: #fff;
        height: 88px;
        padding: 24px 40px 40px 24px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        width: calc(100% + 48px);
        position: relative;
        left: -24px;
		>p {
            .title {
                font-size: 18px;
                font-weight: 700;
            }
        }
        .userMessage-search {
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: 24px;
            left: 50%;
            transform: translateX(-50%);
            /deep/ .el-input {
                width: 350px;
                .el-input__inner {
                    height: 40px;
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 0;
                    border-right: 0;
                }
            }
            .search-btn {
                height: 40px;
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                font-size: 14px;
                padding: 9px 20px;
            }
        }
	}
	.table-content {
		background-color: #fff;
        margin-top:24px;
        padding: 16px;
        // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}
}
.tag-status {
	padding-left: 10px;
	position: relative;
	&:after {
		content: '';
		width: 4px;
		height: 4px;
		border-radius: 50%;
		background-color: @--color-primary;
		position: absolute;
		left: 0;
		top: 50%;
		transform: translateY(-50%);
	}
	&.icon-point-success {
		&:after {
			background-color: #3FBF00;
		}
	}
}
.statusSuccess{
	width: 16px;
	height: 16px;
	display: inline-block;
	background: #1890FF;
	border-radius: 50%;
}
.statusDetault{
	width: 16px;
	height: 16px;
	display: inline-block;
	background: #E8E8E8;
	border-radius: 50%;
}
.statusDanger{
	width: 16px;
	height: 16px;
	display: inline-block;
	background: #F23030;
	border-radius: 50%;
}
.el-table{
	/deep/ .unread-row {
		td{
			font-weight:700;
		}
	}
}
.main-content {
	padding: 0px;
	padding-bottom: 0px;
}

.cate-item {
	height: 36px;
	line-height: 36px;
}

.el-header {
	border-bottom: 1px solid #dcdfe6;
}

.el-aside {
	color: #333;
}
</style>
